import { Injectable } from "@angular/core";
import { Resolve } from "@angular/router";
import { Observable, of } from "rxjs";
import { CivilStatusService } from "../../shared/services/civil-status.service";
import { RelationshipResponse } from "../../shared/models/relationship.model";

@Injectable({
    providedIn: 'root',
})
export class GetRelationshipResolver implements Resolve<RelationshipResponse[]> {

    constructor(
        private relationshipService: CivilStatusService,
    ) { }

    resolve(): Observable<RelationshipResponse[]> {
        return this.relationshipService.getAll();
    }
}
